const TITLE = 'EMR Sign-In'
const MODAL_WIDTH = 560

export { TITLE, MODAL_WIDTH }
